import { BankAccount } from "./bank-account.model";


export interface SurplusLinesOpportunitySnapshotModel {

    Id: number;

    InsuredId: number;
    OpportunityId: number;
    OwnerId: number;

    CurrentTab: string;

    ApplicantIsPolicyOwner: boolean;
    PolicyOwner: string;

    HasOtherInsurance: boolean;
    QuestionnaireId: string;

    PTDSelectedBenefit: number;
    TTDSelectedBenefit: number;

    HeightFt: string;
    HeightIn: string;
    WeightLbs: string;

    Pregnant: boolean;
    PregnancyTreatment: string;
    PregnancyDate: string;

    PaymentPlanId: number;
    PaymentMethod: string;

    BankAccountId: number;
    BankAccount: BankAccount;

    PaymentAccountNickname: string;
    PaymentAccountType: string;
    PaymentRoutingNum: string;
    PaymentAccountNum: string;
    PaymentAuthorized: boolean;

    PaymentMethodIdentifier: string;
    CreditCardPaymentMethodId: string;
    CreditCardFee: number;

    Signature: string;
    SignatureIP: string;

    OtherInsurance: SurplusLinesApplicationOtherInsurance[];
    Questions: SurplusLinesApplicationQuestion[];

    Submitted: boolean;
    SubmittedTimestampSeconds: number;
}

export class SurplusLinesOpportunitySnapshot implements SurplusLinesOpportunitySnapshotModel {
    Id: number = 0;
    InsuredId: number = 0;
    OpportunityId: number = 0;
    OwnerId: number = 0;
    CurrentTab: string = '';
    ApplicantIsPolicyOwner: boolean = false;
    ApplicantId: number = 0;
    PolicyOwner: string = '';
    HasOtherInsurance: boolean = false;
    QuestionnaireId: string = '';
    PTDSelectedBenefit: number = 0;
    TTDSelectedBenefit: number = 0;
    HeightFt: string = '';
    HeightIn: string = '';
    WeightLbs: string = '';
    Pregnant: boolean = false;
    PregnancyTreatment: string = '';
    PregnancyDate: string = '';
    PaymentPlanId: number = 0;
    PaymentMethod: string = '';
    BankAccountId: number = 0;
    BankAccount: BankAccount = new BankAccount();
    PaymentAccountNickname: string = '';
    PaymentAccountType: string = '';
    PaymentRoutingNum: string = '';
    PaymentAccountNum: string = '';
    PaymentAuthorized: boolean = false;
    PaymentMethodIdentifier: string = '';
    CreditCardPaymentMethodId: string = '';
    CreditCardFee: number = 0;
    Signature: string = '';
    SignatureIP: string = '';
    SponsorToken: string = '';
    OtherInsurance: SurplusLinesApplicationOtherInsurance[] = [];
    Questions: SurplusLinesApplicationQuestion[] = [];
    Submitted: boolean = false;
    SubmittedTimestampSeconds: number = 0;
}

export interface SurplusLinesApplicationOtherInsuranceModel {
    Id: number;
    SnapshotId: number;
    Source: string;
    Type: string;
    OtherType: string;
    MonthlyAmount: string;
    EliminationPeriod: string;
    BenefitPeriod: string;
    Paid: string;
}

export class SurplusLinesApplicationOtherInsurance implements SurplusLinesApplicationOtherInsuranceModel {
    Id: number = 0;
    SnapshotId: number = 0;
    Source: string = '';
    Type: string = '';
    OtherType: string = '';
    MonthlyAmount: string = '';
    EliminationPeriod: string = '';
    BenefitPeriod: string = '';
    Paid: string = '';
}

export interface SurplusLinesApplicationQuestionModel {
    Id: number;
    Indent: number;
    SnapshotId: number;

    Section: string;
    SectionName: string;
    SectionSubText: string;
    Step: string;
    QuestionNum: string;
    QuestionText: string;
    QuestionOrder: number;
    NeedsAnswer: boolean;
    NeedsConditionAnswer: boolean;
    AnswerBoolean: boolean;
    AnswerText: string;
    ConditionDate: string;
    ConditionDuration: string;
    ConditionTreatment: string;
    ConditionRecovered: boolean;
    Show: string;
    AnswerType: string;
    TrueHTML: string;
    FalseHTML: string;

    ExplanationQuestions: SurplusLinesApplicationExplanationQuestion[];
}

export class SurplusLinesApplicationQuestion implements SurplusLinesApplicationQuestionModel {
    Id: number = 0;
    Indent: number = 0;
    SnapshotId: number = 0;
    Section: string = '';
    SectionName: string = '';
    SectionSubText: string = '';
    Step: string = '';
    QuestionNum: string = '';
    QuestionText: string = '';
    QuestionOrder: number = 0;
    NeedsAnswer: boolean = false;
    NeedsConditionAnswer: boolean = false;
    AnswerBoolean: boolean = false;
    AnswerText: string = '';
    ConditionDate: string = '';
    ConditionDuration: string = '';
    ConditionTreatment: string = '';
    ConditionRecovered: boolean = false;
    Show: string = '';
    AnswerType: string = '';
    TrueHTML: string = '';
    FalseHTML: string = '';
    ExplanationQuestions: SurplusLinesApplicationExplanationQuestion[] = [];
}

export interface SurplusLinesApplicationExplanationQuestionModel {
    Id: number;
    Indent: number;
    QuestionId: number;
    QuestionNum: string;
    ExplanationQuestionNum: string;
    QuestionText: string;
    AnswerText: string;
    Show: string;
    AnswerType: string;
}

export class SurplusLinesApplicationExplanationQuestion implements SurplusLinesApplicationExplanationQuestionModel {
    Id: number = 0;
    Indent: number = 0;
    QuestionId: number = 0;
    QuestionNum: string = '';
    ExplanationQuestionNum: string = '';
    QuestionText: string = '';
    AnswerText: string = '';
    Show: string = '';
    AnswerType: string = '';
}

export interface SurplusLinesApplicantModel{
    UserId: string;

    Token: string;
    OpportunityRole: string;
    
    FirstName: string;
    LastName: string;
    MI: string;
    BirthDate: string;
    Gender: string;

    Email: string;
    Phone: string;

    UseSSN: boolean;
    SSN: string;
    NPI: string;
    Employer: string;
    JobTitle: string;
    SpecialtyCode: string;
    AnnualIncome: string;

    Address1: string;
    Address2: string;
    City: string;
    State: string;
    PostalCode: string;
}

export class SurplusLinesApplicant implements SurplusLinesApplicantModel{
    UserId: string='';
    Id: number=0;
    Token: string='';
    OpportunityRole: string='';
    
    FirstName: string='';
    LastName: string='';
    MI: string='';
    BirthDate: string='';
    Gender: string='';

    Email: string='';
    Phone: string='';

    UseSSN: boolean=false;
    SSN: string='';
    NPI: string='';
    Employer: string='';
    JobTitle: string='';
    SpecialtyCode: string='';
    AnnualIncome: string='';

    Address1: string='';
    Address2: string='';
    City: string='';
    State: string='';
    PostalCode: string='';
    CompassId: number=0;
    OwnerId: number=0;
}

export class SurplusLinesUserId{
    userId: string = '';
}